import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../../services/translate.service';

@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(key: string) {
    if (key === undefined) {
      return key;
    } else {
      return this.translateService.translate(key);
    }
  }
}
